export default "__VITE_ASSET__0qqUn3qS__"